module.exports = __webpack_public_path__ + "components/flag/static/square/gq-91d218b52078559285d416859acf702c.svg";